<template>
  <div class="ai-idea-bax" v-loading="loading">
        <Tips/>
        <FormBox :app-id.sync="appId"/>
        <AppTitle :key="planId" v-if="!loading"/>
        <IdeaBox/>
  </div>
</template>

<script>
import Tips from './tips.vue'
import FormBox from './formBox.vue'
import AppTitle from './appTitle.vue'
import IdeaBox from './ideaBox'
import { TaskStore } from '@/utils/run-task'
import getMediaInfo from '@/libs/media';
import API from '@/api/marketManage/vivoBatch';
import axios from 'axios';
import { fileConfigList } from './mock'
import { FILE_TYPE } from './constant'
import _ from 'lodash';
import util from '@/libs/utils'
import { validEmoji } from '@/utils/validate';
import {  tipModal } from '../../modal/index';
import COS from '@/libs/cos/Vivo'
import CryptoJS from 'crypto-js';
// util.randomString(20)
export default {
    name: 'AiLaunchIdea',
    props: {
        app_list: {
            type: Array,
            default: () => (
                []
            ),
        },
        taskId: {
            type: [String, Number],
            default: '581'
        },
        planId: {
            type: [String, Number],
            default: '11967711'
        },
        isShow: {
            type: Boolean,
        }
        // 11967711
    },
    components: {
        Tips,
        FormBox,
        AppTitle,
        IdeaBox
    },
    data() {
        return {
           
            uploadStore: new TaskStore(10),//文件上传
            addMaterialStore: new TaskStore(10),//添加素材
            uploadFileListCancelData: {  },
            fileConfigList,
            selectList: {},
            appId: '',
            errFileList: [],
            tempPlatDdata: { video_num:0,image_num:0, title_list: [] },
            searchConfigData: { material_status_map: [], plat_map: [] },
            loading: false,
            appTitleData: {},
            errCoverList: [],
        }
    },
    computed: {
        appList() {
            return this.app_list.map(v=> {
                return {
                    ...v,
                    _app_id: v.app_id, //appid可能为空
                    app_id: v.package_name,//临时改成包名
                    value: v.package_name,
                }
            })
        },
        appMaterialDataResult() {
            return this.appList.reduce((pre,cur)=> {
                const hasTempVideo = this.tempPlatDdata.video_num !== 0;
                const targetAppData = this.selectList[cur.app_id] || { imgList: [], videoList: [] };
                const selectImgData = (()=> {
                    const { image_num } = this.tempPlatDdata
                    const count = targetAppData.imgList.length;
                    const isInt = count !==0 ? count % image_num ===0 : false
                    return {
                        multiple: count/image_num,
                        isInt
                    }
                })();
                const selectVideoData = (()=> {
                    const { video_num } = this.tempPlatDdata
                    const count = targetAppData.videoList.length;
                    const multiple = !hasTempVideo ? 0 : count/video_num
                    const isInt = hasTempVideo ? (count !==0 ? (count % video_num) ===0 : false) : true
                    return {
                        multiple,
                        isInt
                    }
                })();
                const noCoverIndexs = (()=> {
                    if (hasTempVideo) {
                        const list = targetAppData.videoList;
                        return list.reduce((pre, item, index)=> {
                            if (!item[FILE_TYPE.COVER]) {
                                pre.push(index + 1)
                            }
                            return pre;
                        }, [])
                    }else {
                        return [];
                    }
                })();
                const isSuccess = (
                    selectVideoData.isInt && 
                    selectImgData.isInt && 
                    ( !hasTempVideo ||  selectImgData.multiple === selectVideoData.multiple ) &&
                    !noCoverIndexs.length
                );
                const platNum = (
                    selectImgData.isInt && selectVideoData.isInt &&
                    ( !hasTempVideo || selectImgData.multiple === selectVideoData.multiple ) ? 
                    selectImgData.multiple:'-'
                );
                pre[cur.app_id] = {
                    isSuccess, noCoverIndexs, selectVideoData, selectImgData,
                    platNum,
                };
                return pre;
             }, {})
        }
    },
    provide() {
        return {
            aiLaunchGlobal: this
        }
    },
    created() {
      
        this.uploadStore.on('end', ()=> {
            this.showValidateFileErrorData();
            this.showErrCoverTip();
        });
        this.addMaterialStore.on('end', ()=>this.showErrCoverTip());
    },
    methods: {
        delAllCurAppData() { 
             this.selectList[this.appId] = { imgList: [], videoList: [] };
        },
        showErrCoverTip() {
            if (!this.errCoverList.length) {
                return
            }
            const message = this.errCoverList.map(v=> {
                return `<p>${v.material_name}</p>`
            });
            const groupData = _.groupBy(this.errCoverList, (v)=>v.config.conf_resolution);
            const conf_resolution_list = Object.keys(groupData).map(v=> {
                return `【${v}】`
            });
            this.$notify.error({
                title: `错误提示`,
                duration: 0,
                dangerouslyUseHTMLString: true,
                message: `<div style="overflow-y: auto;max-height: 500px">${`以下素材上传失败，没有${conf_resolution_list.join('')}的视频需要添加封面，请先添加视频后再添加封面。`}${message.join('')}<div>` ,
                customClass:'width400',
            });
            this.errCoverList = [];
        },
        updataTitleData(appid, list) {
            this.appTitleData[appid] = list;
        },
        formatFileConfigList(list) {
            return list.map(v=> {
                let format_text = `${v.explicit_name}:${v.conf_resolution};<${v.conf_size_name};${v.conf_format}`;
                if (FILE_TYPE.VIEDO ===v.type) {
                    format_text = `${format_text}; ${v.min_conf_length/1000}s ≤ 时长 ≤ ${v.conf_length/1000}s`
                }
                return {
                    ...v,
                    format_text,
                    format_conf_resolution: v.conf_resolution.split('*'),
                    format_conf_format: v.conf_format.split('\/'),
                }
            })
        },
        handleUploadFile(file, param) {
            const task = async ()=> {
                let cancel = null;
                
                try {
                    const { fileConfig, media } = await this.validateFile(file, param.configList).catch((error)=> {
                        this.errFileList.push(error);
                        return false
                    });
                    if (!fileConfig) {
                        return
                    }
                    const result = await COS.putObject(file, {
                        onTaskReady: (id)=> {
                            let list = this.uploadFileListCancelData[file.key];
                            if (!list) {
                                list = this.uploadFileListCancelData[file.key] = []
                            }
                            list.push(cancel = id);
                            this.$set(this.uploadFileListCancelData, file.key, list)
                        },
                    });
                    const sha1 = await new Promise((resolve, reject)=> {
                    let reader = new FileReader();
                    reader.readAsArrayBuffer(file);
                    reader.onload = function () {
                        var wordArray = CryptoJS.lib.WordArray.create(reader.result);
                        var hash = CryptoJS.SHA1(wordArray).toString();
                        resolve(hash)
                    };
                });
                const params = {
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    ext: file.name.split('.').pop(),
                    md5: JSON.parse(result.ETag),
                    sha1,
                    file_path: result.path,
                    width:media.width,
                    height:media.height,
                    duration: media.duration,
                    region: result.region,
                };
                const { data } = await API.uploadByJd(params)
                    // const formData = new FormData();
                    // formData.append('file', file);
                    // const { data } = await API.vivoBatchPpload(formData, {
                    //     cancelToken: new axios.CancelToken( (c)=> {
                    //         let list = this.uploadFileListCancelData[file.key];
                    //         if (!list) {
                    //             list = this.uploadFileListCancelData[file.key] = []
                    //         }
                    //         list.push(cancel = c);
                    //     }),
                    //     timeout:3600 * 1000,
                    // });
                    this.handleSelectData(true, {
                        ...data, app_id: file.key,config: fileConfig,
                        material_url: data.filePath, material_name: data.name,
                        full_material_url: data.fullFilePath,
                        material_type_id: 2
                    })
                } catch (error) {
                    console.log(error, '上传出错');
                    this.$message.error(error.info)
                }finally {
                    const list = this.uploadFileListCancelData[file.key] || []
                    const index = list.indexOf(cancel);
                    if (index !== -1) {
                        list.splice(index, 1);
                    };
                }
            };
            this.uploadStore.add(task);
        },
        // 提示验证失败的文件
        showValidateFileErrorData() {
            if (!this.errFileList.length) {
                return
            }
            const message = this.errFileList.map(v=> {
                return `<p>${v.name}</p><span>${v.message}</span>`
            })
            this.$notify.error({
                title: '错误',
                duration: 0,
                dangerouslyUseHTMLString: true,
                message: `<div style="overflow-y: auto;max-height: 500px">${message.join('')}</div>`
            });
            this.errFileList = [];
        },
        // 验证文件
        async validateFile(file, configList) {
            const media  = await getMediaInfo(file);
            const ext = file.name.slice(file.name.lastIndexOf('.') + 1);
            
            const formatData = configList.reduce((pre, item)=> {
                pre.size.push(item.conf_size);
                pre.duration.push([item.min_conf_length, item.conf_length]);
                pre.wh.push(item.format_conf_resolution);
                item.format_conf_format.forEach(v=> {
                    pre.format.add(v)
                })
                return pre;
            }, { size: [], duration: [], wh: [], format: new Set() });
           
            const { duration, fileSize, height, width  } = media;
            if (![...formatData.format].some(v=>v === ext)) {
                return Promise.reject({
                    name: file.name,
                    message: '素材格式不符合'
                });
            }
            // 验证大小
            if (!formatData.size.some(v=>fileSize < +v)) {
                return Promise.reject({
                    name: file.name,
                    message: '素材大小不符合'
                });
            }
            if (!formatData.wh.some(([w, h])=>{
                return height === +h && width === +w;
            })) {
                return Promise.reject({
                    name: file.name,
                    message: '素材尺寸不符合'
                });
            }
            // 有时长  视频
            if (duration) {
                if (!formatData.duration.some(([min, max])=>{
                    return duration >= min/1000 && duration <=max/1000;
                })) {
                    return Promise.reject({
                        name: file.name,
                        message: '素材时长不符合'
                    });
                }
            };
            // 统一验证
            const targetConfig = configList.find(item=> {
                const [ w, h] = item.format_conf_resolution;
                const formatList = item.format_conf_format;
                return (
                    fileSize < +item.conf_size &&
                    (height === +h && width === +w) &&
                    formatList.includes(ext)&&
                    (duration ? (duration >= +item.min_conf_length/1000 && duration <=+item.conf_length/1000): true)
                );
            })
            if (!targetConfig) {
                return Promise.reject({
                    name: file.name,
                    message: '素材规格不符合'
                });
            }
            return  { fileConfig:  targetConfig, media} 
        },
        async handleSelectData(check , data) {
            if (Array.isArray(data)) {
                data.forEach(item=> {
                    this.addMaterialStore.add(()=> this.handleSelectData(check, item))
                })
            }else {
                
                const fileData = this.selectList[data.app_id];
                const config = data.config;
                const type = config.type;
                const imgList = fileData?.imgList || [];
                const videoList = fileData?.videoList || [];
                
                if (check) {
                    const pushData = { [type]: data , id: util.randomString(20)}
                    // 视频
                    if (FILE_TYPE.IMAGE === type) {
                        const num = this.tempPlatDdata.image_num;
                        if(imgList.length %num === 0 || imgList.length === 0) {
                            imgList.push(pushData)
                        }else {
                            const md5Data = _.keyBy(_.last(_.chunk(imgList, num)), (item)=>item[type].md5);
                            if (!md5Data[data.md5]) {
                                imgList.push(pushData)
                            }else {
                                const index = _.indexOf(imgList, md5Data[data.md5]);
                                this.$message.error(`重复素材：图片序号 ${ index + 1}重复`)
                            }
                        }
                    }else {
                        const num = this.tempPlatDdata.video_num;
                        if (num === 0) {
                            return
                        }
                        if (FILE_TYPE.VIEDO === type) {
                             
                            if(videoList.length %num === 0 || videoList.length === 0) {
                                videoList.push(pushData)
                            }else {
                                const md5Data = _.keyBy(_.last(_.chunk(videoList, num)), (item)=>item[type].md5);
                                if (!md5Data[data.md5]) {
                                    videoList.push(pushData)
                                }else {
                                    const index = _.indexOf(videoList, md5Data[data.md5]);
                                    this.$message.error(`重复素材：视频序号 ${ index + 1}重复`)
                                }
                            }
                        }else {
                            // 封面
                            let targetVideoData = null;
                            if (data.id) {
                                targetVideoData = _.find(videoList, { id:  data.id});
                            }else {
                                 targetVideoData = videoList.find(item=> {
                                    const data = item[FILE_TYPE.VIEDO];
                                    const cover = item[FILE_TYPE.COVER];
                                    const videoConfig = data.config;
                                    return (
                                        !cover &&
                                        config.conf_resolution === videoConfig.conf_resolution
                                    )
                                });
                            }
                            if (targetVideoData) {
                                this.$set(targetVideoData, FILE_TYPE.COVER, data)
                            }else {
                                // 没有匹配的封面
                                console.log('没有匹配的封面', data);
                                
                                if(!(this.uploadStore.loading || this.addMaterialStore.loading)) {
                                    this.$message.error(`没有【${data.config.conf_resolution}】的视频需要添加封面，请先添加视频后再添加封面。`)
                                }else {
                                    this.errCoverList.push(data);
                                }
                            }
                        }
                    };
                    this.$set(data, 'id', util.randomString(20))
                }else {
                    let targetList = []
                    // 取消选择
                    if (type === FILE_TYPE.IMAGE) {
                       targetList = imgList
                    }else {
                       targetList = videoList
                    };
                    const targetData = targetList.find(v=> {
                        const item = v[type];
                        return item && data.id === item.id
                    });
                    if ([FILE_TYPE.IMAGE, FILE_TYPE.VIEDO].includes(type)) {
                        targetList.splice(targetList.indexOf(targetData), 1)
                    }else {
                        targetData[type] = undefined;
                    }
                }
                this.$set(this.selectList, data.app_id, { imgList, videoList })
                console.log(this.selectList, 'this.selectListthis.selectListthis.selectList');
                
            };
        },
        // 停止上传
        cancelUploadFile(key) {
            Object.values(this.uploadFileListCancelData).forEach(list=> {
                list.map(v=>{
                    try {
                        COS.cancelTask(v)
                    } catch (error) {
                        console.log(error, '取消上传出错');
                    }
                })
            });
            this.uploadStore.stopAllTask()
        },
        async getSmartProductUploadConfig() {
            try {
                this.loading = true
                const params = {
                    task_id: this.taskId,// 579
                    plan_id: this.planId
                }
                const { data } = await API.getSmartProductUploadConfig(params)
                this.fileConfigList = this.formatFileConfigList(data.material_config);
                const { video_num,image_num, title_list  } = data;
                this.tempPlatDdata = { video_num,image_num, title_list };
                this.$bus.$emit('updateListData');
            } catch (error) {
                console.log('获取配置失败');
            }finally {
                this.loading = false
            }
        },
        async getWorkOrderSearchConfig() {
            const { data } = await API.getWorkOrderSearchConfig();
            this.searchConfigData = data;
        },
        async validateFn() {
            const { video_num,image_num } = this.tempPlatDdata;
            const fromatAppData = _.groupBy(this.appList, 'app_id');
            const mapAppData = _.map(this.appList, 'app_id');
            const { errTitleList, errMaterialList } = _.reduce(mapAppData, (result,appid)=> {
                const titleData =  this.appTitleData[appid] || [];
                console.log(titleData, 'titleDatatitleData');
                
                const valid = titleData.every((title=> {
                    return (
                        !validEmoji(title) &&
                        !/\{|\}|\s/.test(title)&&
                        !!title
                    )
                }));
                const { app_name, _app_id } = fromatAppData[appid][0];
                if(!valid) {
                    result.errTitleList.push(`${app_name}(${ _app_id })`)
                };
                const materialData = this.appMaterialDataResult[appid];
                if(!materialData.isSuccess) {
                    result.errMaterialList.push(`${app_name}(${ _app_id })`)
                }
                return result;
            }, { errTitleList: [], errMaterialList: [] });
           
            const errRepeatList = [];
            let index = 0;
            const validData = ({ num, originList , type, typeName, app_name})=> {
                const dataChunkList = _.chunk( originList, num);
                dataChunkList.forEach((chunkList, chunkNum)=> {
                    const mapList = _.map(chunkList, type);
                    const groupData = _.groupBy(mapList, 'md5' )
                    const l =  Object.keys(groupData);
                    if(l.length !== num) {
                        Object.values(groupData).forEach(list=> {
                            if(list.length > 1) {
                                index++;
                                const errList = _.map(list, (item)=> {
                                    return (mapList.indexOf(item) + 1) + (chunkNum * num)
                                });
                                errRepeatList.push(`${app_name} 重复素材${index}: ${typeName}序号${errList.join('、')}重复`)
                            }
                        })
                    }
                });
            }
            mapAppData.forEach((appid)=> {
                const { app_name } = fromatAppData[appid][0];
                validData({
                    num: image_num,
                    originList:  this.selectList[appid]?.imgList ||[],
                    type: FILE_TYPE.IMAGE,
                    typeName: '图片',
                    app_name
                })

                if(video_num !==0) {
                    validData({
                        num: video_num,
                        originList:  this.selectList[appid]?.videoList ||[],
                        type: FILE_TYPE.VIEDO,
                        typeName: '视频',
                        app_name
                    })
                }
                
            });
            if(errTitleList.length > 0 || errMaterialList.length > 0 || errRepeatList.length > 0) {
                return Promise.reject(_.filter([
                    {
                        title: '每个产品最少需要拥有一个标题，并且符合输入要求，请检查',
                        list: errTitleList
                    },
                    {
                        title: '每个产品已上传素材需要均为满足状态，以下产品不满足，请检查',
                        list: errMaterialList
                    },
                    {
                        title: '目前上传的素材生成计划后同一个计划内存在重复素材，请修改',
                        list: errRepeatList
                    },
                ], (item)=> item.list.length > 0))
            }else {
                return mapAppData.map(appid=> {
                    const data =  {
                        package_name: appid,
                        title_list:  this.appTitleData[appid] || this.tempPlatDdata.title_list,
                        title_list:  this.appTitleData[appid] || this.tempPlatDdata.title_list,
                        img_list: ( this.selectList[appid]?.imgList || []).map(item=> {
                            const { material_url, material_name } = item[FILE_TYPE.IMAGE]
                            return {  
                                material_url, material_name 
                            };
                        }),
                        video_list: [],
                    };
                    if (video_num !==0) {
                        data.video_list = ( this.selectList[appid]?.videoList || []).map(item=> {
                            const VIEDO = item[FILE_TYPE.VIEDO];
                            const COVER= item[FILE_TYPE.COVER];
                            return {  
                                material_url: VIEDO.material_url, 
                                material_name : VIEDO.material_name,
                                preview_material_url : COVER.material_url,
                                preview_material_name : COVER.material_name,
                                id: VIEDO._id,
                                type:  VIEDO.material_type_id || 1
                            };
                        })
                    }
                    return data;
                })
            }

        },
    },
    watch: {
        planId(val) {
            this.appTitleData = {}
        },
        isShow(val) {
            if (!val) {
                return
            }
            const data = _.head(this.appList);
            console.log(data, 'datadatadatadata');
            
            if(data) {
                this.getSmartProductUploadConfig()
                this.getWorkOrderSearchConfig()
                this.appId = data.value;
                this.$bus.$emit('updataFormData', { appId: data.value });
                this.$bus.$emit('updataFormNameData', data.app_name);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.ai-idea-bax {
    min-height: 700px;
}
.title-group{
    font-size: 14px;
    margin-bottom: 20px;
}
</style>